import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import MetaTags from 'react-meta-tags';
import KeyFeatureBox from '../../components/about/KeyFeatureBox';
import SectionTitle from '../../components/about/SectionTitle';
import { aboutData } from '../../data';
import { useAuth } from '../../store/auth';
import { aboutDataArabic } from '../../data/indexArabic';

const About = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? aboutData : aboutDataArabic;
  const [isSeeMore, setIsSeeMore] = useState(false);

  const toggleSeeMore = (e) => {
    e.preventDefault();
    setIsSeeMore(!isSeeMore);
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>About | Subul Contracting</title>
      </MetaTags>

      {data && (
        <>
          <section className="bg-half-170 bg-light d-table w-100">
            <Container>
              <Row className="mt-5 justify-content-center">
                <Col lg={12} className="text-center">
                  <div className="pages-heading">
                    <h1 className="title mb-0">{data?.aboutUsCmsData?.page_heading}</h1>
                  </div>
                </Col>
              </Row>
              <div className="position-breadcrumb">
                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                    {data?.aboutUsCmsData?.breadcrumb?.map((item, index) => (
                      <li className={item?.className} key={index}>
                        {item?.link ? <Link to={item.link}>{item.name}</Link> : item?.name}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </Container>
          </section>

          <div className="position-relative">
            <div className="shape overflow-hidden text-white">
              <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
              </svg>
            </div>
          </div>

          <section className="section">
            <Container>
              <Row className="align-items-center">
                <Col lg={5} md={5}>
                  <div className="position-relative">
                    <img src={data?.aboutUsCmsData?.img} className="rounded-3 shadow-sm img-fluid mx-auto d-block" alt="Our Story at Subul Contracting" />
                  </div>
                </Col>
                <Col lg={7} md={7} className="mt-4 pt-2 mt-md-0 pt-md-0">
                  <div className="section-title ms-lg-4">
                    <h4 className="title mb-4">{data?.aboutUsCmsData?.title}</h4>
                    <p className="text-muted">
                      {data?.aboutUsCmsData?.our_story?.description?.map((ele, index) => (
                        <span key={index} className={ele.highlight ? "text-primary fw-bold" : ""}>{ele.content}</span>
                      ))}
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section bg-light">
            <Container>
              <Row className="justify-content-center">
                <Col lg={12} className="text-center pb-2">
                  <h2 className="title">Our Key Features</h2>
                </Col>
              </Row>
              {data?.aboutUsCmsData?.key_features && (
                <SectionTitle
                  isLeft={false}
                  keyFeatures={data?.aboutUsCmsData?.key_features}
                />
              )}
              <Row>
                {data?.aboutUsCmsData?.key_features?.key_features_list && (
                  <KeyFeatureBox
                    isSeeMore={isSeeMore}
                    keyfeatures={data?.aboutUsCmsData?.key_features?.key_features_list}
                  />
                )}
                <Col xs={12} className="text-center mt-4 pt-2">
                  <Link to="#" className="btn btn-primary rounded-pill" onClick={toggleSeeMore}>
                    {isSeeMore ? data?.aboutUsCmsData?.hideMore : data?.aboutUsCmsData?.seeMore}{' '}
                    <i className={`mdi mdi-arrow-${isSeeMore ? 'up' : 'down'}`}></i>
                  </Link>
                </Col>
              </Row>
            </Container>
          </section>
        </>
      )}
    </React.Fragment>
  );
};

export default About;